import { default as MuiSwitch, SwitchProps } from '@mui/material/Switch'

const Switch = (props: SwitchProps) => {
  return <MuiSwitch {...props} />
}

export default Switch
